import React, { useContext } from 'react';

// CONTEXT
import { ToastContext } from 'context/ToastContext';

// COMPONENTS
import TooltipComponent from '../tooltipComponent';
import TileSpecificInfo from './TileSpecificInfo';

// SERVICES
import { insertTileStat } from 'services/statService';

const LinkTile = ({ user_id, tile_id, title, desc, url, isPrivate, imageUrl, onPrivateClick, isEditing = false, isViewing = false, userEmail = null, currentBreakpoint = 'lg' }) => {
  const { addToast } = useContext(ToastContext);

  const shouldShowImage = () => {
    // Masquer l'image en mode xs (mais pas en xxs)
    return currentBreakpoint !== 'xs';
  };

  const handleClick = (e) => {
    if (isPrivate) {
      e.preventDefault();
      addToast('Connexion au réseau', 'Oups ! Il semble que vous ne soyez pas connecté au réseau de l\'entreprise 🔒', () => openFortiClient(), 'Activer le VPN', 'warning');
      if (onPrivateClick) {
        onPrivateClick();
      }
    } else {
      insertTileStat(user_id, tile_id);
    }
  };

  const openFortiClient = () => {
    window.location.href = 'forticlient://open';
  };

  return (
    <>
    {!isEditing && !isViewing ? (
      <TooltipComponent title={desc} placement="bottom">
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full h-full p-4 rounded-lg flex flex-col justify-end relative"
          style={{ textDecoration: 'none' }}
          onClick={handleClick}
        >
           {/* Affichage des informations spécifiques à la tuile en haut à droite */}
           <div className="absolute top-2 right-2">
             <TileSpecificInfo 
               tileTitle={title} 
               userEmail={userEmail}
               currentBreakpoint={currentBreakpoint}
             />
           </div>
           {imageUrl && shouldShowImage() && (
             <img src={imageUrl} alt={title} className="size-8 object-cover rounded-lg" />
           )}
          <h3 className="sm:text-sm text-xs poppins-bold text-blanc overflow-hidden text-ellipsis" charset="UTF-8">{title}</h3>
          <p className="text-xs text-blanc overflow-hidden md:line-clamp-2 md:display-none" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }} charset="UTF-8">{desc}</p>
          
        </a>
      </TooltipComponent>
    ) : (
      <div className="w-full h-full p-4 rounded-lg flex flex-col justify-end relative">
         {/* Affichage des informations spécifiques à la tuile en haut à droite (mode édition/visualisation) */}
         <div className="absolute top-2 right-2">
           <TileSpecificInfo 
             tileTitle={title} 
             userEmail={userEmail}
             currentBreakpoint={currentBreakpoint}
           />
         </div>
         {imageUrl && shouldShowImage() && (
           <img src={imageUrl} alt={title} className="size-8 object-cover rounded-lg" />
         )}
        <h3 className="sm:text-sm text-xs poppins-bold text-blanc overflow-hidden text-ellipsis" charset="UTF-8">{title}</h3>
        <p className="text-xs text-blanc overflow-hidden md:line-clamp-2 md:display-none" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }} charset="UTF-8">{desc}</p>
        
      </div>
    )}
    </>
  );
};

export default LinkTile;